/* =============================================================
   Birth Profile Analyst, Cookievoorkeuren
   -------------------------------------------------------------
   Bouwt een venster waarin bezoekers hun cookies beheren.
   Open via elk element met het attribuut [data-cookie-prefs].
   Keuze wordt bewaard in localStorage onder 'bpa_cookie_prefs'.
   ============================================================= */
(function () {
  "use strict";
  var STORE = "bpa_cookie_prefs";
  var COMPANY = "Birth Profile Analyst";
  var LANG = (localStorage.getItem("bpa_lang") || "nl") === "en" ? "en" : "nl";

  /* ---- bewaarde keuze inlezen ---- */
  function readPrefs() {
    try { return JSON.parse(localStorage.getItem(STORE)) || null; }
    catch (e) { return null; }
  }
  function savePrefs(p) {
    p.at = new Date().toISOString();
    try { localStorage.setItem(STORE, JSON.stringify(p)); } catch (e) {}
  }

  /* ---- teksten (NL / EN) ---- */
  var T = {
    nl: {
      eyebrow: "Privacy", title: "Cookievoorkeuren", close: "Sluiten",
      intro: COMPANY + " gebruikt cookies om de website te laten werken, het gebruik te analyseren en de inhoud te verbeteren. Kies hieronder zelf welke cookies je toestaat. Lees meer in ons <a href=\"Privacybeleid.html\">privacybeleid</a>.",
      always: "Altijd aan", onlyNecessary: "Alleen noodzakelijk", save: "Mijn keuze opslaan", acceptAll: "Alles accepteren",
      cats: {
        necessary: { title: "Noodzakelijk", desc: "Nodig om de website te laten werken, denk aan je winkelwagen, beveiliging en taalkeuze. Deze cookies kunnen niet worden uitgeschakeld." },
        analytics: { title: "Analytisch", desc: "Helpen ons te begrijpen hoe bezoekers de site gebruiken, zodat we " + COMPANY + " kunnen verbeteren. Volledig anoniem." },
        marketing: { title: "Marketing", desc: "Worden gebruikt om advertenties en content af te stemmen op jouw interesses, ook op andere platforms." }
      }
    },
    en: {
      eyebrow: "Privacy", title: "Cookie preferences", close: "Close",
      intro: COMPANY + " uses cookies to make the website work, analyse usage and improve its content. Choose below which cookies you allow. Read more in our <a href=\"Privacybeleid.html\">privacy policy</a>.",
      always: "Always on", onlyNecessary: "Only necessary", save: "Save my choice", acceptAll: "Accept all",
      cats: {
        necessary: { title: "Necessary", desc: "Needed to make the website work, such as your cart, security and language choice. These cookies cannot be switched off." },
        analytics: { title: "Analytics", desc: "Help us understand how visitors use the site so we can improve " + COMPANY + ". Fully anonymous." },
        marketing: { title: "Marketing", desc: "Used to tailor ads and content to your interests, including on other platforms." }
      }
    }
  };
  var L = T[LANG];

  /* ---- categorieën ---- */
  var CATS = [
    { key: "necessary", locked: true, title: L.cats.necessary.title, desc: L.cats.necessary.desc },
    { key: "analytics", title: L.cats.analytics.title, desc: L.cats.analytics.desc },
    { key: "marketing", title: L.cats.marketing.title, desc: L.cats.marketing.desc }
  ];

  /* ---- stijl (één keer) ---- */
  function injectStyle() {
    if (document.getElementById("bpa-cookie-style")) return;
    var css =
      ".bpa-cc-overlay{position:fixed;inset:0;z-index:9999;display:none;align-items:center;justify-content:center;" +
        "padding:24px;background:rgba(5,11,26,0.74);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px)}" +
      ".bpa-cc-overlay.show{display:flex;animation:bpaccFade .35s ease}" +
      "@keyframes bpaccFade{from{opacity:0}to{opacity:1}}" +
      ".bpa-cc-panel{width:100%;max-width:560px;max-height:88vh;overflow-y:auto;background:linear-gradient(180deg,#0d1f42,#0a1733);" +
        "border:1px solid rgba(201,169,106,0.35);box-shadow:0 30px 80px rgba(0,0,0,0.5);position:relative;" +
        "animation:bpaccUp .4s cubic-bezier(.2,.7,.2,1)}" +
      "@keyframes bpaccUp{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:none}}" +
      ".bpa-cc-panel::before{content:'';position:absolute;top:0;left:0;right:0;height:1px;" +
        "background:linear-gradient(90deg,transparent,#c9a96a,transparent)}" +
      ".bpa-cc-head{padding:30px 32px 0}" +
      ".bpa-cc-eyebrow{font-family:'JetBrains Mono',ui-monospace,monospace;font-size:9px;letter-spacing:.35em;" +
        "text-transform:uppercase;color:#c9a96a;margin:0 0 10px}" +
      ".bpa-cc-title{font-family:'EB Garamond','Times New Roman',serif;font-weight:500;font-size:30px;color:#f3ead6;margin:0 0 12px}" +
      ".bpa-cc-intro{font-family:'Mulish',system-ui,sans-serif;font-size:13.5px;line-height:1.7;color:#cfd6e8;margin:0 0 6px}" +
      ".bpa-cc-intro a{color:#e7c98a;text-decoration:underline;text-underline-offset:2px}" +
      ".bpa-cc-list{padding:22px 32px 6px;display:flex;flex-direction:column;gap:2px}" +
      ".bpa-cc-cat{border-top:1px solid rgba(201,169,106,0.18);padding:18px 0;display:flex;gap:16px;align-items:flex-start}" +
      ".bpa-cc-cat:first-child{border-top:none}" +
      ".bpa-cc-cattext{flex:1}" +
      ".bpa-cc-catname{font-family:'Mulish',system-ui,sans-serif;font-size:15px;font-weight:600;color:#f3ead6;margin:0 0 5px;display:flex;align-items:center;gap:9px}" +
      ".bpa-cc-tag{font-family:'JetBrains Mono',ui-monospace,monospace;font-size:8px;letter-spacing:.16em;text-transform:uppercase;" +
        "color:#c9a96a;border:1px solid rgba(201,169,106,0.4);padding:2px 7px}" +
      ".bpa-cc-catdesc{font-family:'Mulish',system-ui,sans-serif;font-size:12.5px;line-height:1.6;color:#8b94ad;margin:0}" +
      /* toggle */
      ".bpa-cc-toggle{flex:0 0 auto;width:46px;height:26px;border-radius:40px;border:1px solid rgba(201,169,106,0.4);" +
        "background:rgba(8,18,42,0.7);position:relative;cursor:pointer;transition:background .25s,border-color .25s;margin-top:2px}" +
      ".bpa-cc-toggle::after{content:'';position:absolute;top:2px;left:2px;width:20px;height:20px;border-radius:50%;" +
        "background:#8b94ad;transition:transform .25s,background .25s}" +
      ".bpa-cc-toggle.on{background:rgba(201,169,106,0.22);border-color:#c9a96a}" +
      ".bpa-cc-toggle.on::after{transform:translateX(20px);background:#c9a96a}" +
      ".bpa-cc-toggle.locked{cursor:not-allowed;opacity:.85}" +
      ".bpa-cc-toggle.locked.on::after{background:#c9a96a}" +
      /* actions */
      ".bpa-cc-actions{display:flex;flex-wrap:wrap;gap:12px;padding:18px 32px 30px;border-top:1px solid rgba(201,169,106,0.18);margin-top:8px}" +
      ".bpa-cc-btn{flex:1;min-width:150px;padding:14px 18px;font-family:'JetBrains Mono',ui-monospace,monospace;font-size:10px;" +
        "letter-spacing:.22em;text-transform:uppercase;cursor:pointer;transition:background .25s,color .25s,border-color .25s,letter-spacing .25s;border:1px solid rgba(201,169,106,0.4);background:transparent;color:#cfd6e8}" +
      ".bpa-cc-btn:hover{border-color:#c9a96a;color:#f3ead6;letter-spacing:.28em}" +
      ".bpa-cc-btn.primary{background:#c9a96a;border-color:#c9a96a;color:#0a1733}" +
      ".bpa-cc-btn.primary:hover{background:#e7c98a;color:#0a1733}" +
      ".bpa-cc-close{position:absolute;top:18px;right:18px;width:34px;height:34px;border:1px solid rgba(201,169,106,0.3);" +
        "background:transparent;color:#8b94ad;cursor:pointer;font-size:18px;line-height:1;display:grid;place-items:center;transition:color .25s,border-color .25s}" +
      ".bpa-cc-close:hover{color:#c9a96a;border-color:#c9a96a}" +
      "@media (max-width:560px){.bpa-cc-head{padding:26px 22px 0}.bpa-cc-list{padding:18px 22px 4px}.bpa-cc-actions{padding:16px 22px 26px}.bpa-cc-title{font-size:25px}}" +
      /* trigger onderaan de pagina */
      ".bpa-cookie-bar{display:flex;justify-content:center;padding:46px 24px 4px}" +
      ".bpa-cookie-trigger{display:inline-flex;align-items:center;gap:10px;background:transparent;" +
        "border:1px solid rgba(201,169,106,0.35);color:#8b94ad;font-family:'JetBrains Mono',ui-monospace,monospace;" +
        "font-size:10px;letter-spacing:.24em;text-transform:uppercase;padding:13px 24px;cursor:pointer;" +
        "transition:color .25s,border-color .25s,background .25s,letter-spacing .25s}" +
      ".bpa-cookie-trigger:hover{color:#0a1733;background:#c9a96a;border-color:#c9a96a;letter-spacing:.3em}" +
      ".bpa-cookie-trigger svg{width:14px;height:14px;flex:0 0 auto}";
    var s = document.createElement("style");
    s.id = "bpa-cookie-style";
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ---- venster bouwen ---- */
  var overlay, toggles = {};
  function build() {
    if (overlay) return;
    injectStyle();
    overlay = document.createElement("div");
    overlay.className = "bpa-cc-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", L.title);

    var panel = document.createElement("div");
    panel.className = "bpa-cc-panel";

    var head = document.createElement("div");
    head.className = "bpa-cc-head";
    head.innerHTML =
      '<button class="bpa-cc-close" type="button" aria-label="' + L.close + '">&times;</button>' +
      '<p class="bpa-cc-eyebrow">' + L.eyebrow + '</p>' +
      '<h2 class="bpa-cc-title">' + L.title + '</h2>' +
      '<p class="bpa-cc-intro">' + L.intro + '</p>';
    panel.appendChild(head);

    var list = document.createElement("div");
    list.className = "bpa-cc-list";
    var saved = readPrefs() || {};
    CATS.forEach(function (cat) {
      var row = document.createElement("div");
      row.className = "bpa-cc-cat";
      var on = cat.locked ? true : (saved[cat.key] === true);
      var tog = document.createElement("button");
      tog.type = "button";
      tog.className = "bpa-cc-toggle" + (on ? " on" : "") + (cat.locked ? " locked" : "");
      tog.setAttribute("role", "switch");
      tog.setAttribute("aria-checked", on ? "true" : "false");
      tog.setAttribute("aria-label", cat.title);
      if (!cat.locked) {
        tog.addEventListener("click", function () {
          var nowOn = !tog.classList.contains("on");
          tog.classList.toggle("on", nowOn);
          tog.setAttribute("aria-checked", nowOn ? "true" : "false");
        });
      }
      toggles[cat.key] = tog;

      var txt = document.createElement("div");
      txt.className = "bpa-cc-cattext";
      txt.innerHTML =
        '<p class="bpa-cc-catname">' + cat.title +
        (cat.locked ? ' <span class="bpa-cc-tag">' + L.always + '</span>' : '') + '</p>' +
        '<p class="bpa-cc-catdesc">' + cat.desc + '</p>';

      row.appendChild(txt);
      row.appendChild(tog);
      list.appendChild(row);
    });
    panel.appendChild(list);

    var actions = document.createElement("div");
    actions.className = "bpa-cc-actions";
    var bOnly = mkBtn(L.onlyNecessary, false, function () {
      collect(function (k) { return false; }); close();
    });
    var bSave = mkBtn(L.save, false, function () {
      collect(null); close();
    });
    var bAll = mkBtn(L.acceptAll, true, function () {
      collect(function (k) { return true; }); close();
    });
    actions.appendChild(bOnly);
    actions.appendChild(bSave);
    actions.appendChild(bAll);
    panel.appendChild(actions);

    overlay.appendChild(panel);
    document.body.appendChild(overlay);

    /* sluiten */
    head.querySelector(".bpa-cc-close").addEventListener("click", close);
    overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && overlay.classList.contains("show")) close();
    });
  }

  function mkBtn(label, primary, fn) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "bpa-cc-btn" + (primary ? " primary" : "");
    b.textContent = label;
    b.addEventListener("click", fn);
    return b;
  }

  /* override: forceer alle niet-locked toggles op een waarde, of lees huidige stand */
  function collect(forceFn) {
    var p = {};
    CATS.forEach(function (cat) {
      if (cat.locked) { p[cat.key] = true; return; }
      if (forceFn) {
        var v = forceFn(cat.key);
        p[cat.key] = v;
        toggles[cat.key].classList.toggle("on", v);
        toggles[cat.key].setAttribute("aria-checked", v ? "true" : "false");
      } else {
        p[cat.key] = toggles[cat.key].classList.contains("on");
      }
    });
    savePrefs(p);
  }

  function open() { build(); requestAnimationFrame(function(){ overlay.classList.add("show"); }); }
  function close() { if (overlay) overlay.classList.remove("show"); }

  /* ---- knoppen koppelen ---- */
  document.addEventListener("click", function (e) {
    var trig = e.target.closest && e.target.closest("[data-cookie-prefs]");
    if (trig) { e.preventDefault(); open(); }
  });

  /* stijl meteen laden zodat de knop onderaan de pagina goed oogt */
  if (document.head) injectStyle();
  else document.addEventListener("DOMContentLoaded", injectStyle);

  window.BPACookiePrefs = { open: open, get: readPrefs };
})();
